import JiraProject from '../enums/JiraProject'
import createAPIClient from '../services/apiClient'
import BugInput from '../types/BugInput'
import IssueInput from '../types/IssueInput'
import { getWafRequestConfig } from '../utils/wafCaptcha'

const api = createAPIClient('v2')

export async function sendBug(input: BugInput, project: JiraProject) {
  const response = await api.post(`/jira/${project}/bugs`, input)
  return response.data
}

export async function sendIssue(input: IssueInput, project: JiraProject, wafToken?: string) {
  const response = await api.post(`/jira/${project}/issue`, input, getWafRequestConfig(wafToken))
  return response.data
}
